import React from 'react';

export type LabelProp = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLSpanElement>,
  HTMLSpanElement
>;

export const GenericLabel = (props: LabelProp) => {
  return <span {...props} className={`${props.className || ''}`}></span>;
};

export const ActiveLabel = (props: LabelProp & {active?: boolean}) => {
  return (
    <GenericLabel
      {...props}
      className={`cursor-pointer my-auto flex p-[8px_10px] justify-center items-center gap-[10px] rounded-[6px] ${
        props.active
          ? 'bg-[#F0F1F3] text-black dark:bg-[#3e3e3e] dark:text-white'
          : 'text-[#BEBEBE]'
      } text-[12px] font-bold`}></GenericLabel>
  );
};

export const SmLabel = (props: LabelProp) => {
  return (
    <GenericLabel
      {...props}
      className={`${props.className || ''} text-sm`}></GenericLabel>
  );
};
